import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';

export const isEmpty = (entity: any) => _isEmpty(entity);
export const cloneDeep = (entity: any) => _cloneDeep(entity);
export const formatCurrency = (number: number) => Intl.NumberFormat('en-US').format(number) + ' đ';
export const formatNumber = (number: number) => Intl.NumberFormat('en-US').format(number);
export const formatShortCurrency = (number: number) => {
    switch (true) {
        case number >= 1e9: {
            const billions = (number / 1_000_000_000).toFixed(2)
            return `${billions} tỷ`
        }
        case number >= 1e6: {
            const millions = Math.floor(number / 1e6)
            return `${millions} tr`
        }
        default: {
            return formatCurrency(number)
        }
    }
}

type Parsed = {
    numberMonth?: number;        // 6 | 12 | 24
    phoneAgency?: string;        // optional
    phoneSim: string;            // required
    serialSim: string;           // required
    phoneCustomer?: string;      // optional
    customerName?: string;       // optional
};

export const reNumberMonthDataPack = /^(?:\s*(6|12|24))?\s*([A-Za-z][A-Za-z0-9_-]*)\s*$/;
const reMonth = /^(6|12|24)[tT]$/;
const rePhoneSim = /^(?:169|0169)?\d{7}$/;        // Position 3 (required)
const reSerialSim = /^\d{19}$/;                    // Position 4 (required)
const rePhoneGeneric = /^(?:\+?84|0)?\d{9,10}$/;      // VN phone (agency/customer)

/**
 * Parse chuỗi syntax -> object, kiểm tra hợp lệ 16 biến thể
 */
export function parseSyntax(input: string): Parsed {
    const tokens = input.trim().split(/\s+/);
    if (tokens.length < 2) {
        throw new Error("Không đủ token: cần tối thiểu phoneSim và serialSim");
    }

    const out: Partial<Parsed> = {};
    let i = 0;

    // Position 1: Optional numberMonth (6t|12t|24t)
    if (tokens[i] && reMonth.test(tokens[i])) {
        out.numberMonth = parseInt(tokens[i].toLowerCase().replace("t", ""), 10);
        i++;
    }

    // Position 2: Optional phoneAgency (có rollback nếu ăn nhầm phoneSim)
    let agencyCandidate: string | undefined;
    if (tokens[i] && rePhoneGeneric.test(tokens[i])) {
        agencyCandidate = tokens[i];
        i++;
    }

    // Position 3: Required phoneSim
    if (!tokens[i] || !rePhoneSim.test(tokens[i])) {
        // rollback: nếu agencyCandidate thực chất chính là phoneSim
        if (agencyCandidate && rePhoneSim.test(agencyCandidate)) {
            i--; // quay lại vị trí agencyCandidate
            agencyCandidate = undefined;
        }
    }
    if (!tokens[i] || !rePhoneSim.test(tokens[i])) {
        throw new Error("phoneSim (position 3) không hợp lệ hoặc thiếu");
    }
    out.phoneSim = tokens[i];
    i++;

    // Position 4: Required serialSim
    if (!tokens[i] || !reSerialSim.test(tokens[i])) {
        throw new Error("serialSim (position 4) không hợp lệ hoặc thiếu");
    }
    out.serialSim = tokens[i];
    i++;

    // Chốt agency nếu còn hợp lệ
    if (agencyCandidate) out.phoneAgency = agencyCandidate;

    // Position 5: Optional phoneCustomer
    if (tokens[i] && rePhoneGeneric.test(tokens[i])) {
        out.phoneCustomer = tokens[i];
        i++;
    }

    // Position 6: Optional customerName (phần còn lại join)
    if (i < tokens.length) {
        out.customerName = tokens.slice(i).join(" ").trim().toUpperCase();
    }

    return out as Parsed;
}
